/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./NavigatorDialog',
	'react',
	'react-dom'
], function(NavigatorDialog, React, ReactDOM) {

	class OpenDialog extends NavigatorDialog {
		constructor(options) {
			super(options);
			this.dialogTitle = options.dialogTitle;
			this.subHeaderText = options.subHeaderText;
			this.onOpen = options.onOpenCallback;
			this.onCancelCallback = options.onCancelCallback;
			this.primaryBtnText = options.primaryBtnText;
			this.typesToOpen = [].concat(options.typesToOpen|| []);
			this.multiSelect = options.multiSelect;
			this.filtersByTypes = this._getFiltersByTypes(options);
			this.dataManipulationCallback = options.dataManipulationCallback;
			this.url = options.url;
			this.selfUrl = options.selfUrl;
			this.rootObjects = options.rootObjects;
			this.teamContentOnly = options.teamContentOnly || false;
			this.alwaysShowTeamContent = options.alwaysShowTeamContent || false;
			this.capabilitiesRequired = options.capabilitiesRequired;
			this.extraUrlParameters = options.extraUrlParameters;

			this.isOpen = false;
		}

		_getFiltersByTypes(options) {
			const { filtersByTypes, typesToOpen } = options;
			if (filtersByTypes && filtersByTypes.length > 0) {
				return filtersByTypes;
			} else if (typesToOpen && typesToOpen.length > 0) {
				return ['folder|package|' + typesToOpen.join('|')];
			} else {
				return [];
			}
		}

		open() {
			this.isOpen = true;
			return this.render();
		}

		onClose() {
			this.isOpen = false;
			const mountPoint = document.getElementById('openDialog');
			ReactDOM.unmountComponentAtNode(mountPoint);
			mountPoint.parentNode.removeChild(mountPoint);
		}

		render() {
			return this._getFolderData().then((folderInfo) => {
				const options = {
					onOpen: this.onOpen,
					glassContext: this.glassContext,
					isOpen: this.isOpen,
					onClose: this.onClose.bind(this),
					dialogTitle: this.dialogTitle,
					subHeaderText: this.subHeaderText,
					onCancelCallback: this.onCancelCallback,
					primaryBtnText: this.primaryBtnText,
					typesToOpen: this.typesToOpen,
					filtersByTypes: this.filtersByTypes,
					dataManipulationCallback: this.dataManipulationCallback,
					url: this.url,
					selfUrl: this.selfUrl,
					ancestors: this.ancestors,
					rootObjects: this.rootObjects,
					teamContentOnly: this.teamContentOnly,
					alwaysShowTeamContent: this.alwaysShowTeamContent,
					singleSelect: !this.multiSelect,
					selectedTabId: folderInfo.tab,
					pathRef: folderInfo.folder,
					capabilitiesRequired: this.capabilitiesRequired,
					extraUrlParameters: this.extraUrlParameters
				};
	
				let mountPoint = document.createElement('div');
				mountPoint.setAttribute('id', 'openDialog');
				document.body.appendChild(mountPoint);
	
				return new Promise((resolve, reject) => {
					require(['ca-content/home/caHome'], (caHome) => {
						ReactDOM.render(React.createElement(caHome.OpenDialog, options), mountPoint);
						resolve();
					}, reject);
				});
			});
		}

	}
	return OpenDialog;
});
